import formurlencoded from 'form-urlencoded';

export default function exportTrack(payload) {
  return function(dispatch) {
    return new Promise((resolve, reject) => {
      fetch(REST_URL+'tracks/export', {
        credentials: 'include',
        method: 'post',
        headers: {'Content-Type': 'application/x-www-form-urlencoded' },
        body: formurlencoded({trackIds: payload})
      }).then(response => response.json())
      .then(json => {
          dispatch({
            type: 'TRACKS_EXPORTED',
            payload: payload
          });
          window.location = json['zipUrl'];
          resolve();
        },
        () => reject()
      );
    });
  }
};
